import _ from "lodash";

function hasPermission(granted, required) {
    granted = granted ? Array.isArray(granted) ? granted : [granted] : [];
    required = required ? Array.isArray(required) ? required : [required] : [];

    return !!_.intersection(granted, required).length;
}

export default hasPermission;



/** WEBPACK FOOTER **
 ** ./app/utils/functions/hasPermission.js
 **/